module.exports = __webpack_public_path__ + "img/8-mob.327c94eb.svg";